/**
 * Empty state components for workspace management
 */

import React from 'react';

interface WorkspaceEmptyStateProps {
  hasFilters: boolean;
  onCreateWorkspace?: () => void;
  onClearFilters: () => void;
}

export function WorkspaceEmptyState({ hasFilters, onCreateWorkspace, onClearFilters }: WorkspaceEmptyStateProps) {
  if (hasFilters) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">🔍</div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No workspaces found</h3>
        <p className="text-gray-500 mb-4">
          No workspaces match your current filters. Try adjusting your search criteria.
        </p>
        <button
          className="access-btn access-secondary"
          onClick={onClearFilters}
        >
          Clear Filters
        </button>
      </div>
    );
  }

  return (
    <div className="text-center py-12">
      <div className="text-6xl mb-4">🏢</div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">No workspaces yet</h3>
      <p className="text-gray-500 mb-4">
        Get started by creating your first workspace.
      </p>
      {onCreateWorkspace && (
        <button
          className="access-btn access-primary"
          onClick={onCreateWorkspace}
        >
          Create Workspace
        </button>
      )}
    </div>
  );
}

export function WorkspaceLoadingSkeleton() {
  return (
    <div className="animate-pulse space-y-4">
      <div className="h-32 bg-gray-200 rounded-lg"></div>
      <div className="h-32 bg-gray-200 rounded-lg"></div>
      <div className="h-32 bg-gray-200 rounded-lg"></div>
    </div>
  );
}

interface WorkspaceErrorStateProps {
  onRetry: () => void;
  error: string;
}

export function WorkspaceErrorState({ onRetry, error }: WorkspaceErrorStateProps) {
  return (
    <div className="text-center py-12">
      <div className="text-6xl mb-4">⚠️</div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">Error loading workspaces</h3>
      <p className="text-gray-500 mb-4">{error}</p>
      <button
        className="access-btn access-primary"
        onClick={onRetry}
      >
        Try Again
      </button>
    </div>
  );
}
